import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { COLORS } from "Constants/BIDashboardConstants"

import './GDCurrencyCodeCell.scss';

const GDCurrencyCodeCell = ({ extraClass, value = null, units = '', customClass = '' , headerClass , currencyClass }) => {
  const wrapperClass = classnames('gd-currency-code-cell ', {
    [extraClass]: extraClass,
  });

  const handlePrecision = (amount, precision) => {
    const arr = amount.split('.');
    return arr.length > 1
      ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
      : `${amount <= 0 ? amount * -1 : amount}.00`;
  };

  const trueValue = Number.parseFloat(value);
  const displayValue = (Number.isNaN(trueValue))
    ? '-'
    : handlePrecision(value.toString(), 2);

  return (
    <div className={wrapperClass} style={{display:'inline-flex'}}>
      <span className={`gd-currency-code-cell ${headerClass}`}>{displayValue}</span>&nbsp;
        <span style={{color:`${COLORS.oneGp.charcoal}`}} className={`case-overview-pane ${currencyClass}`}>{units}</span>
    </div>
  );
};

GDCurrencyCodeCell.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  units: PropTypes.string,
  extraClass: PropTypes.string,
  customClass: PropTypes.string,
};

GDCurrencyCodeCell.defaultProps = {
  extraClass: '',
  units: '',
  customClass: '',
};

export default GDCurrencyCodeCell;
